// John Eldhose 20190110
import { RestfulPost } from './Restful';

export async function addLMDRMA(data) {
  const rma = await RestfulPost('addLMDRMA', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return rma;
}



// WEBPACK FOOTER //
// ./src/Api/addLMDRMA.js